import React, { useEffect, useState } from "react";
import group from "./img/gourp.png"; // Ensure this path is correct
import FounderPersin from "./FounderPerson";
import Heading from "../../components/Highlightedheading/Heading";
import Pageheading from "../../components/PageHeading/Pageheading";
import { RiHome2Line } from "react-icons/ri";
import { useWindowSize } from "react-use";
import Image32 from "../../assets/founder/Banner.png";
import mobileImage from "../../assets/founder/Banner_Mobile.png";

import { founderAssets } from "../../assets/founder";
import FounderPersonNew from "./FounderPersonNew";
import BannerHeading from "../../components/BannerHeading/Heading";

const Founder = () => {
  const [readmoreIndex, setReadMoreIndex] = useState(null);
  const { width } = useWindowSize();

  const founderData = [
    {
      image: founderAssets?.ruchinarain,
      firstName: "ruchi",
      lastName: "narain",
      designation: "co - founder",
      descToShow: `
      Ruchi Narain is a distinguished and Multi-award winning
      Writer, Director, and Producer, who thrives on the challenge
      of straddling a variety of genres across formats. From feature
      films to gripping series, advertising commercials to
      documentaries, she's done it all!
      <br />
      <br />
      Originally hailing from Delhi, she had a whirlwind of global
      experiences, hopping from Dubai and Muscat to Colombo and
      Doha. This jet-setting upbringing, led to her collecting
      schools as if they were Pokemon's, a total of 12, including
      Woodstock in Mussoorie and USC! Now, she's proudly embracing
      her identity as a Bombayite, having called the city home for
      several years.
      <br />
      <br />
      Kickstarting her filmmaking journey in 1996, she later won the
      Filmfare Award for her screenplay for Hazaaron Khwahishein
      Aisi (2003). Her directorial debut, KAL (Yesterday &
      Tomorrow), received the Osian's Cinefan Critic's Choice Award.
      She was the writer and director of the critically acclaimed
      Netflix thriller Guilty (2020), produced by Karan Johar's
      Dharmatic Entertainment, starring Kiara Advani, Gurfateh
      Pirzada, and Taher Shabbir.
      `,
      readMore: `
      She wrote and directed Hanuman Da Damdaar (2017), India's
      largest animation release yet, produced by R.A.T Films and
      RNB Films, featuring Salman Khan as Hanuman. Narain
      co-created and co-directed Hundred (2020), an 8-part
      comedy series starring Lara Dutta and Rinku Rajguru for
      Disney Hotstar. The tryst with Disney Hotstar continued as
      writer, director, and showrunner for Karmma Calling
      (2024), the Indian adaptation of ABC’s Revenge, starring
      Raveena Tandon, Varun Sood, and Namrata Sheth.
      <br />
      <br />
      Her versatility extends to directing ground-breaking ad
      films. Narain pioneered the social experiment format with
      her multi-award-winning film ‘The Divide’ on financial
      literacy for women, created for PayTM, which became a
      viral sensation.
      <br />
      <br />
      From FMCG, beauty, appliances, and automobiles, she has
      directed numerous commercials, of which, the most
      memorable ones include Magic Bricks, JK Tyres, Lloyds, and
      Kellogg’s. She led a successful multi-starrer campaign for
      the National Literacy Mission. Testament to her success is
      evidenced by how she’s never had only a one-time
      collaboration with an agency or client, as they repeatedly
      rely on her to create impactful campaigns.
      <br />
      <br />
      Beyond her impressive filmography, she has produced
      projects for emerging directors, award-winning wildlife
      documentaries for Discovery Channel, short films, music
      videos, and commercials.
      <br />
      <br />
      Off-set, Narain loves spending quality time with her young
      daughter Vira, who's in primary school. You might spot her
      with her nose in a book, swimming laps, indulging her
      passion for horse riding or her culinary prowess. If
      you're lucky, you might even catch her serenading friends
      and family with her beautiful voice, belting out her
      favourite tunes.
      <br />
      <br />
      Phew! Talk about being multitalented!
      `,
    },
    {
      image: founderAssets?.ashutoshshah,
      firstName: "ashutosh",
      lastName: "shah",
      designation: "co - founder",
      descToShow: `
      Ashutosh Shah, director, producer, and co-founder of R.A.T Films, is known for seamlessly blending creativity with impact across genres and formats. Raised in Mumbai, Ashutosh’s fascination with the arts began young, inspiring him to dive into dramatics, painting, and directing in his school days, later strengthened by his education at Narsee Monjee College and KC College, where he specialised in Mass Media.
      <br />
      <br />
      Ashutosh's cinematic journey was propelled by the mentorship of industry giants like Santosh Sivan, who opened his eyes to the world of photography and the magic of motion pictures. His directorial debut a hard-hitting documentary on Naxalism—earned accolades and international recognition, setting him on a fast track in his  Bollywood journey.
      <br />
      <br />
      Since then, Ashutosh has made his mark with standout projects. His directorial debut in the public service music video  Shiksha Ka Suraj, featuring Shah Rukh Khan, Kareena Kapoor, Priyanka Chopra, and Anil Kapoor, was hailed as the "Mile Sur of this Millennium" and became an instant hit.
      `,
      readMore: `
      His filmography is as versatile as it is impressive, with key roles in Khoya Khoya Chand, Once Upon a Time in Mumbai, Agneepath, and as 2nd Unit Director on Bhaag Milkha Bhaag, Guilty, and Fitoor. R.A.T Films, founded with Ruchi Narain and Taher Shabbir, has become synonymous with high-quality, impactful projects. The company’s animated hit  Hanuman Da Damdaar,  voiced by Salman Khan and other Bollywood stars, became India’s largest animated release, while Ashutosh’s foray into OTT with Disney+ Hotstar’s  Hundred saw him co-create, direct, and produce a comedy series starring Lara Dutta and Rinku Rajguru. His recent work,  Karmma Calling, the Indian adaptation of  Revenge, brings him full circle with Disney Hotstar, led by Raveena Tandon.
      <br />
      <br />
      His advertising journey began as the go-to 1st assistant for industry giants like Prakash Varma and numerous international directors, gaining hands-on experience across over 400 high-impact commercials. Since then, he’s taken his expertise to the next level, producing over 100 ads through his production house, R.A.T Films for various leading brands. One of his standout projects, The Divide, became a viral sensation, sparking conversations around women’s financial literacy. As an advertising director, Ashutosh’s work features many Bollywood Superstars and cool comic campaigns for FMCG brands.
      <br />
      <br />
      Ashutosh’s dual expertise as a producer and director gives him a unique edge in delivering story-driven content with precision and impact. Today, Ashutosh Shah is celebrated as a young producer who combines dedication with a bold vision, inspiring his industry peers and constantly pushing the boundaries of filmmaking.
      <br />
      <br />
      Beyond the set, Ashutosh is a modern explorer—sampling the latest food trends, experimenting with new tech, and enjoying time with his dog and twin daughters. A foodie who’s mastered healthy eating, a tech enthusiast, and a music lover with a passion for drums, Ashutosh Shah is always seeking new ways to stay inspired, blending art and impact in everything he creates. 
      `,
    },
    {
      image: founderAssets?.tahershabbir,
      firstName: "Taher",
      lastName: "Shabbir ",
      designation: "co - founder",
      descToShow: `
      Taher Shabbir is an Actor, Director, Producer, and Writer—a one-man cinematic powerhouse! 
      <br />
      <br />
      As co-founder of RAT Films, Shabbir has produced several groundbreaking brand commercials, web series and feature films, including an adaptation of the American series Revenge for Disney Hotstar called Karmma Calling (2024) starring Raveena Tandon, Varun Sood and Namrata Sheth. He co-created and co-directed Hundred an 8-part comedy series starring Lara Dutta and Rinku Rajguru, in 2020 as well as produced the popular animated feature Hanuman Da Dumdaar (2017).
      <br />
      <br />
      As an actor, Taher charmed audiences as the slick lawyer Danish Ali Baig in Netflix's thriller Guilty (2020), opposite Kiara Advani. He played the sinister villain Naman Rana in Disney Hotstar’s Kaala (2023). He continued to win hearts with roles in series, commercials, and films and also garnered much praise and affection for his portrayal of Jai in Naam Shabana (2017), and Sangram Singh in Manikarnika (2019) amongst many others. He also starred in the Cannes award-winning film Exchange Offer (2020). 
      `,
      readMore: `
      He began his cinematic journey alongside his good friend and now RAT Films co-founder, Ashutosh Shah. They plunged into the world of documentaries with a college project on Naxalism, and their debut swept up awards at multiple festivals, marking the beginning of their legendary partnership, and later collaborating with acclaimed filmmakers like Madhur Bhandarkar and Sudhir Mishra, contributing to several feature films. He transitioned into major commercial projects as the first AD and Second Unit Directors on Bollywood blockbusters such as Once Upon a Time in Mumbai, directed by Milan Luthria and produced by Balaji Films, and Karan Johar's epic Agneepath. He, along with Ashutosh, soon took on the role of executive producer for director Sudhir Mishra.
      <br />
      <br />
      His directorial debut was nothing short of spectacular, with the public service music video Shiksha ka Suraj. This video, featuring Bollywood icons like Shah Rukh Khan, Kareena Kapoor, Priyanka Chopra, Anil Kapoor, Farhan Akhtar, and Shabana Azmi, was hailed by the press as "the Mile Sur of this Millennium" and became a viral sensation. Following this triumph, Taher co-directed the Skoda Prize Film for the Indian Contemporary Art Prize in 2012. Throughout his career, he has also collaborated with advertising legends such as Prakash Varma, Uzer Khan, Amit Sharma, Vinil Mathew, Farouk Al Joffrey, and a slew of international ad directors. 
      <br />
      <br />
      When he's not on set, you may find him indulging in his love for ghazals, sharing his passion for Shayari, or strumming a few tunes on his guitar. 
      <br />
      <br />
      Taher Shabbir: the man who can do it all and then some!
      `,
    },
  ];

  useEffect(() => {
    const preloadImages = [Image32, mobileImage];
    preloadImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <>
      <div className="relative w-full  h-[90vh] md:h-[40vw] 3xl:h-[60vh] flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-transparent z-10">
          <div className="md:pl-[5.63vw] pl-4 flex items-center md:pt-[10.09vw] pt-[25vw]">
            <Pageheading pageHeading={"Founders"} icon={<RiHome2Line />} />
          </div>
        </div>
        <div
          className="absolute inset-0 bg-contain md:bg-cover bg-no-repeat bg-[center_bottom] md:bg-right-bottom flex justify-center items-center"
          style={{
            backgroundImage: `url(${width < 768 ? mobileImage : Image32})`,
          }}
        >
          <div className="absolute top-[25vh] md:top-[15vw] md:left-[17.47vw] flex justify-start items-center z-10">
            <BannerHeading headingText={"FOUNDERS"} />
          </div>
        </div>
        <div className="absolute h-[250px] md:h-[300px] tab:h-[327px] w-full top-0 bg-gradient-to-b from-[#121614]"></div>
      </div>

      <section className="relative">
        <div className="w-full px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px] pb-[50px]">
          {/* <h2 className="text-left w-full text-[40px] leading-[40px] sm:text-[80px] sm:leading-[80px] 3xl-plus:text-[94px] 3xl-plus:leading-[94px] font-bebas_neue text-transparent bg-clip-text bg-text-gradient">
            OUR FOUNDERS
          </h2> */}
          <h2
            data-aos="fade-up"
            className="text-left w-full text-[11vw] md:text-[5.5vw] leading-[11vw] md:leading-[5.5vw] font-bebas_neue text-transparent bg-clip-text bg-text-gradient"
          >
            OUR FOUNDERS
          </h2>
          <div className="mt-8 flex flex-col gap-12">
            <FounderPersonNew
              founder={founderData[0]}
              id={1}
              customCss="xl:scale-100 2xl-plus:scale-[1.3] 3xl-plus:scale-[1.4]"
            />
            <div className="hidden md:block border-[1px] opacity-[15%] border-[#ffff] md:w-[80%] mx-auto my-20 3xl-plus:my-40"></div>
            <FounderPersonNew
              founder={founderData[1]}
              reverse
              customCss="xl:scale-100 2xl-plus:scale-[1.2] 3xl-plus:scale-[1.3]"
            />
            <div className="hidden md:block border-[1px] opacity-[15%] border-[#ffff] md:w-[80%] mx-auto my-20 3xl-plus:my-40"></div>
            <FounderPersonNew
              founder={founderData[2]}
              customCss="xl:scale-100 2xl-plus:scale-[1.2] 3xl-plus:scale-[1.3]"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Founder;
